import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\GetStockableDossierItemsController::__invoke
* @see app/Http/Controllers/Dossier/GetStockableDossierItemsController.php
* @route '/api/dossier/{dossier}/stockable-items'
*/
const GetStockableDossierItemsController = (args: { dossier: string | number } | [dossier: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetStockableDossierItemsController.url(args, options),
    method: 'get',
})

GetStockableDossierItemsController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/stockable-items',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\GetStockableDossierItemsController::__invoke
* @see app/Http/Controllers/Dossier/GetStockableDossierItemsController.php
* @route '/api/dossier/{dossier}/stockable-items'
*/
GetStockableDossierItemsController.url = (args: { dossier: string | number } | [dossier: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: args.dossier,
    }

    return GetStockableDossierItemsController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\GetStockableDossierItemsController::__invoke
* @see app/Http/Controllers/Dossier/GetStockableDossierItemsController.php
* @route '/api/dossier/{dossier}/stockable-items'
*/
GetStockableDossierItemsController.get = (args: { dossier: string | number } | [dossier: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetStockableDossierItemsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\GetStockableDossierItemsController::__invoke
* @see app/Http/Controllers/Dossier/GetStockableDossierItemsController.php
* @route '/api/dossier/{dossier}/stockable-items'
*/
GetStockableDossierItemsController.head = (args: { dossier: string | number } | [dossier: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetStockableDossierItemsController.url(args, options),
    method: 'head',
})

export default GetStockableDossierItemsController